import Vue from 'vue'
import App from './App.vue'
import router from './router'
//默认样式reset
import '@/assets/css/reset.css'
import '@/assets/css/icon.css'
import rem from '@/rem'
import * as ajax from '@/request'
import clipboard from 'clipboard';
// vant
import Vant from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant)
Vue.prototype.$http = ajax;
Vue.prototype.globaldata = {};
Vue.prototype.clipboard = clipboard;
Vue.config.productionTip = false

const CHUNK_RELOAD_FLAG = '__wanfang_h5_chunk_reload__'

function safeSessionStorage(action, key, value) {
  try {
    if (action === 'get') {
      return window.sessionStorage.getItem(key)
    }

    if (action === 'set') {
      window.sessionStorage.setItem(key, value)
    }

    if (action === 'remove') {
      window.sessionStorage.removeItem(key)
    }
  } catch (error) {
    return ''
  }

  return ''
}

router.beforeEach((to, from, next) => {
  if (to.meta.isAuthRequired === true) {
    if (safeSessionStorage('get', 'Token')) {
      next()
      return
    } else {
      next({
        name: 'Login',
        params: {
          from: to.path
        }
      })
      return
    }
  }
  next()
})

router.onError(error => {
  const message = (error && error.message) || ''
  const isChunkError =
    /Loading chunk \d+ failed/i.test(message) ||
    /Loading CSS chunk \d+ failed/i.test(message) ||
    /ChunkLoadError/i.test(message)

  if (!isChunkError) {
    return
  }

  const currentPath = window.location.pathname + window.location.search + window.location.hash
  const hasRetried = safeSessionStorage('get', CHUNK_RELOAD_FLAG) === '1'

  if (hasRetried) {
    safeSessionStorage('remove', CHUNK_RELOAD_FLAG)
    window.location.replace(`/p/blankpage?currentpath=${encodeURIComponent('/report')}`)
    return
  }

  safeSessionStorage('set', CHUNK_RELOAD_FLAG, '1')
  window.location.replace(currentPath)
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
